import { useState } from "react";
import { Fragment } from "react";
import { useEffect } from "react";

import { Button } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import gtag from "ga-gtag";
import { useSnackbar } from "notistack";

import WizardAssessmentParticipants from "../assessments/wizardAssessmentParticipants";
import WizardAssessmentResults from "../assessments/wizardAssessmentResults";
import WizardAssessmentSelection from "../assessments/wizardAssessmentSelection";
import WizardPerformAssessment from "../assessments/wizardPerformAssessment";
import Dialog from "../ui/omniDialog";
import DialogTitle from "../ui/omniDialogTitle";
import OmniEditButton from "../ui/omniEditButton";

const AssessmentWizardDialog = props => {
  const {
    open,
    displayResultsAssessmentODM = null,
    dialogTitle = "Assessment Coach",
    maxWidth = "sm",
    fullWidth = true,
    lockAssessmentOmniType = null,
    autoStartAssessment = false,
    lockSubjectODM = null,
    botpressAssessment = false,
  } = props;

  const theme = useTheme();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [tabIndex, setTabIndex] = useState(0);

  //Set by tab 0
  const [assessmentODM, setAssessmentODM] = useState(null);
  //set by tab 1
  const [assessmentProctorODM, setAssessmentProctorODM] = useState(null);
  const [assessmentSubjectODM, setAssessmentSubjectODM] = useState(lockSubjectODM);
  //set by tab 2
  const [completedAssessmentODM, setCompletedAssessmentODM] = useState(null);
  const [updatedSubjectODM, setUpdatedSubjectODM] = useState(null);
  const [updatedProctorODM, setUpdatedProctorODM] = useState(null);
  //Tab 3 is the Results tab

  useEffect(() => {
    if (displayResultsAssessmentODM) {
      setTabIndex(3);
      setCompletedAssessmentODM(displayResultsAssessmentODM);
    }
  }, [setTabIndex, displayResultsAssessmentODM, setCompletedAssessmentODM]);

  useEffect(() => {
    if (assessmentODM && tabIndex === 0) {
      setTabIndex(1);
      gtag("event", "omni_page_view", {
        omni_page_title: "select_subject",
        omni_page_location: `${window.location}assessment/select_subject`,
      });
    } else if (!assessmentODM && tabIndex === 0) {
      gtag("event", "omni_page_view", {
        omni_page_title: "select_assessment",
        omni_page_location: `${window.location}assessment/select_assessment`,
      });
    }
  }, [tabIndex, setTabIndex, assessmentODM]);

  useEffect(() => {
    if (assessmentProctorODM && assessmentSubjectODM && tabIndex === 1) {
      // gtag("event", "omni_assessment_start_click", {
      //   omni_assessment_type: completedAssessmentODM.omniData.omniType
      // });
      setTabIndex(2);
    }
  }, [assessmentProctorODM, assessmentSubjectODM, tabIndex, setTabIndex]);

  useEffect(() => {
    if (completedAssessmentODM && updatedSubjectODM && updatedProctorODM && tabIndex === 2) {
      setTabIndex(3);
    }
  }, [tabIndex, setTabIndex, completedAssessmentODM, updatedSubjectODM, updatedProctorODM]);

  const onAcceptHandler = () => {
    props.onAccept();
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const startOver = () => {
    gtag("event", "omni_assessment_restart");
    setTabIndex(0);
    setAssessmentODM(null);
    setAssessmentProctorODM(null);
    setAssessmentSubjectODM(lockSubjectODM);
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          enqueueSnackbar("Are you sure you want to quit?", {
            variant: "warning",
            action: key => (
              <Fragment>
                <OmniEditButton
                  sx={{
                    marginLeft: "4px",
                    backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    border: `2px solid ${lighten(theme.palette.warning.main, 0.75)}`,
                    "&:hover": {
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                      filter: "brightness(85%)",
                    },
                  }}
                  color="info"
                  variant="contained"
                  onClick={() => {
                    onCloseHandler();
                    closeSnackbar(key);
                  }}
                >
                  Yes
                </OmniEditButton>
                <Button
                  sx={{
                    marginLeft: "4px",
                    backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    border: `2px solid ${lighten(theme.palette.warning.main, 0.75)}`,
                    "&:hover": {
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                      filter: "brightness(85%)",
                    },
                  }}
                  color="info"
                  variant="contained"
                  onClick={() => {
                    closeSnackbar(key);
                  }}
                >
                  No
                </Button>
              </Fragment>
            ),
          });
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      keepMounted
    >
      <DialogTitle
        onClose={() => {
          if (displayResultsAssessmentODM) {
            onCloseHandler();
          } else {
            enqueueSnackbar("Are you sure you want to quit?", {
              variant: "warning",
              action: key => (
                <Fragment>
                  <Button
                    sx={{
                      marginLeft: "4px",
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                      border: `2px solid ${lighten(theme.palette.warning.main, 0.75)}`,
                      "&:hover": {
                        backgroundColor: lighten(theme.palette.warning.main, 0.5),
                        filter: "brightness(85%)",
                      },
                    }}
                    color="info"
                    variant="contained"
                    onClick={() => {
                      gtag("event", "omni_assessment_abandoned");
                      onCloseHandler();
                      closeSnackbar(key);
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    sx={{
                      marginLeft: "4px",
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                      border: `2px solid ${lighten(theme.palette.warning.main, 0.75)}`,
                      "&:hover": {
                        backgroundColor: lighten(theme.palette.warning.main, 0.5),
                        filter: "brightness(85%)",
                      },
                    }}
                    color="info"
                    variant="contained"
                    onClick={() => {
                      closeSnackbar(key);
                    }}
                  >
                    No
                  </Button>
                </Fragment>
              ),
            });
          }
        }}
      >
        {dialogTitle}
      </DialogTitle>
      {tabIndex === 0 && (
        <WizardAssessmentSelection
          lockAssessmentOmniType={lockAssessmentOmniType}
          autoStartAssessment={autoStartAssessment}
          key={"WizardAssessmentSelection"}
          setAssessmentODM={setAssessmentODM}
        />
      )}
      {tabIndex === 1 && (
        <WizardAssessmentParticipants
          botpressAssessment={botpressAssessment}
          key={"WizardAssessmentParticipants"}
          onCancel={startOver}
          subjectODM={lockSubjectODM}
          setAssessmentProctorODM={setAssessmentProctorODM}
          setAssessmentSubjectODM={setAssessmentSubjectODM}
          selfAssessment={assessmentODM.omniData.selfAssessment}
        />
      )}
      {tabIndex === 2 && (
        <WizardPerformAssessment
          key={"WizardPerformAssessment"}
          onCancel={startOver}
          originalAssessmentODM={assessmentODM}
          subjectODM={assessmentSubjectODM}
          proctorODM={assessmentProctorODM}
          setCompletedAssessmentODM={setCompletedAssessmentODM}
          setUpdatedSubjectODM={setUpdatedSubjectODM}
          setUpdatedProctorODM={setUpdatedProctorODM}
          onClose={onCloseHandler}
        />
      )}

      {tabIndex === 3 && (
        <WizardAssessmentResults
          key={"WizardAssessmentResults"}
          completedAssessmentODM={completedAssessmentODM}
          updatedSubjectODM={updatedSubjectODM}
          updatedProctorODM={updatedProctorODM}
          onAccept={onAcceptHandler}
          onClose={onCloseHandler}
        />
      )}
    </Dialog>
  );
};

export default AssessmentWizardDialog;
